import React from 'react';
import { TeaserListing } from '@massds/mayflower-react';

import './index.scss';

export default (props) => <TeaserListing {...props} />;
